<template>
  <div class="favourite-items">
    <h1 class="title">Favourite Items</h1>

    <div
      v-if="is_loading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <div class="row mt-2 px-4">
      <p v-if="favourite_items.length === 0">You have no favourite items yet!</p>

      <div
        v-else
        v-for="favourite_item in favourite_items"
        :key="favourite_item.id"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-sx-12"
      >
        <menu-item-card
          :object_id="favourite_item.id"
          :title="favourite_item.attributes.menu_item.data.attributes.name"
          button_text="Add to Cart"
          button_classes="bg-white text-primary border-0"
          :image_source="favourite_item.attributes.menu_item.data.attributes.image_url"
          card_classes="m-4 menu-item-card"
          @card_button_click="showMenuItem(favourite_item.attributes.menu_item.data.id)"
          :price="favourite_item.attributes.menu_item.data.attributes.price"
          :favourite_links="true"
          :is_favourite="favourite_item.attributes.menu_item.data.attributes.favourite"
          @favourite_button_click="removeFavourite(favourite_item.attributes.menu_item.data.attributes.favourite_item_id)"
        ></menu-item-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getFavouriteItems, destroyFavouriteItem } from '../store/api'
import Card from "../components/card";
import MenuItemModal from "../components/menu_item_modal";

export default {
  name: 'favourite_items',

  components: {
    'menu-item-card': Card,
    'menu-item-modal': MenuItemModal,
  },

  data() {
    return {
      favourite_items: [],
      is_loading: true,
    }
  },

  created() {
    getFavouriteItems()
      .then(response => {
        this.favourite_items = response.data
        this.is_loading = false
      })
  },

  methods: {
    showMenuItem(menu_item_id) {
      this.$router.push(`menu_items/${menu_item_id}`)
    },
    removeFavourite(favourite_item_id) {
      destroyFavouriteItem(favourite_item_id)
        .then(response => {

          this.favourite_items = this.favourite_items.filter((favourite_item) => {
            return favourite_item.id != favourite_item_id
          })
        })
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  .favourite-items {
    text-align: center;
  }
  .row {
    justify-content: center;
  }
</style>
